<template>
  <div class="site-audit">
    <audit-head />
    <div class="contentcontainer contentcontainer--nopadding">
      <b-tabs card vertical>
        <b-tab title="Summary">
          <AuditOverview
                  v-bind:audit="audit"
                  v-bind:date="dateFormatted"
          />
        </b-tab>
        <b-tab title="Modified Core Files">
          <AuditCoreFiles
                v-bind:id="audit.id"
                v-bind:date="dateFormatted"
                v-bind:files="audit.module_modifiedfiles"
          />
        </b-tab>
        <b-tab title="Suspicious Files Checker">
          <AuditSuspiciousFiles
                v-bind:id="audit.id"
                v-bind:date="dateFormatted"
                v-bind:files="audit.module_suspiciousfiles"
                v-bind:site_id="audit.site_id"
                v-bind:ignoredfiles="siteDetail.data.file_ignorelist"
          />
        </b-tab>
        <b-tab title="Joomla Configuration"  v-if="audit.module_joomlaconfiguration && audit.module_joomlaconfiguration.length">
          <AuditJoomlaConfig
                v-bind:date="dateFormatted"
                v-bind:audits="audit.module_joomlaconfiguration"
          />
        </b-tab>
        <b-tab title="User Database" v-if="audit.module_users && typeof audit.module_users.weak_passwords !== 'undefined'">
          <AuditUsers
                v-bind:date="dateFormatted"
                v-bind:audits="audit.module_users"
          />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import AuditOverview from './AuditOverview'
import AuditJoomlaConfig from './AuditJoomlaConfig'
import AuditCoreFiles from './AuditCoreFiles'
import AuditUsers from './AuditUsers'
import AuditSuspiciousFiles from './AuditSuspiciousFiles'
import AuditHead from './AuditHead'
import moment from 'moment'

import { mapMutations, mapState } from 'vuex'

export default {
  name: 'TheAudit',
  components: {
    AuditHead,
    AuditOverview,
    AuditJoomlaConfig,
    AuditCoreFiles,
    AuditSuspiciousFiles,
    AuditUsers
  },

  methods: {
    ...mapMutations([
      'setViewname'
    ]),

    ...mapMutations('common', [
      'startLoading',
      'endLoading'
    ])
  },

  computed: {
    ...mapState('audit', ['audit']),
    ...mapState('site', ['siteDetail']),

    dateFormatted () {
      return moment(this.audit.finished_at).format('DD.MM.YYYY')
    }
  }
}
</script>
